import React from 'react';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import ScrollAnimation from 'react-animate-on-scroll';

import Button from '@material-ui/core/Button';

import dentalOffices from '../assets/images/dentalOffices.jpg';
import medicalOffices from '../assets/images/medicalOffices.jpg';
import optometryOffices from '../assets/images/optometryOffices.jpg';
import chiropracticOffices from '../assets/images/chiropracticOffices.jpg';
import urgentCareOffices from '../assets/images/urgentCareOffices.jpg';
import pharmacyOutlets from '../assets/images/pharmacyOutlets.jpg';
import clinicsAndHospitals from '../assets/images/clinicsAndHospitals.jpg';
import imageryAndLaboratoryOffices from '../assets/images/imageryAndLaboratoryOffices.jpg';

const useStyles = makeStyles(theme => ({
    container: {
        paddingTop: "100px",
        paddingBottom: "50px",
        paddingLeft: "15%",
        paddingRight: "15%",
        backgroundColor: theme.palette.background.bg2,
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "5%",
            paddingRight: "5%",
        },
    },
    box: {
        "&:hover": {
            "& h2": {
                color: theme.palette.primary.main,
                letterSpacing: 1,
            },
            "& img": {
                opacity: 0.5
            }
        },
        [theme.breakpoints.down("sm")]: {
            marginBottom: "10px"
        },
    },
    serviceText: {
        marginTop: "10px",
        lineHeight: 1.5,
        paddingLeft: "10px",
        paddingRight: "10px",
        marginBottom: "10px",
        letterSpacing: 0,
        fontSize: "18px",
        transition: "0.5s"
    },
    more: {
        width: "25%",
        border: `solid ${theme.palette.primary.main} 1px`,
        cursor: "pointer",
        transition: "0.5s",

        [theme.breakpoints.down("md")]: {
            fontSize: "14px",
        },
        [theme.breakpoints.down("xs")]: {
            fontSize: "10px",
        },

        "&:hover": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.common.white
        },
    },
}))


export default function Services() {
    const classes = useStyles();
    const theme = useTheme();
    const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
    const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));
    const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

    return (
        <React.Fragment>
            <Grid container direction="column" className={classes.container} id="services">

                <ScrollAnimation animateIn="slideInLeft" animateOnce={true}>
                    <Grid item>
                        <Typography component="h1" variant="h2" gutterBottom>SERVICES</Typography>
                    </Grid>
                    <Grid item>
                        <Typography component="h1" variant="h1" paragraph>What We Offer</Typography>
                    </Grid>
                </ScrollAnimation>
                <Grid item>
                    <Typography component="p" variant="body1">
                        Our services include free; site search, site visit, site selection, space planning, preparing
                        construction cost proposal and estimating construction completion time.
                        Our team of professionals will evaluate the site or space to determine the most cost-effective
                        solution for the entire project.
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography component="p" variant="body1" paragraph>
                        Our interior designers create attractive medical or dental environments that combine pleasant
                        ambiance with cost effective, innovative yet practical design solutions in use of materials,
                        furnishings, finishes and lightings.
                    </Typography>
                </Grid>

                <Grid item container direction="row" justify="center">
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={dentalOffices} alt="dentalOffices design"
                                 style={{
                                     width: "100%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: matchesSM ? null : "22%",
                                     clipPath: matchesSM ? "polygon(0% 20%, 100% 0%, 100% 100%, 0% 100%)"
                                         : "polygon(0% 20%, 100% 0%, 100% 100%, 0% 100%)",
                                 }}
                            />
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Dental offices
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={medicalOffices} alt="medicalOffices design"
                                 style={{
                                     width: "100%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     clipPath: matchesSM ? "polygon(0% 0%, 100% 20%, 100% 100%, 0% 100%)"
                                         : "polygon(0% 20%, 100% 0%, 100% 100%, 0% 100%)",
                                 }}
                            />
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Medical offices
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={optometryOffices} alt="carpet"
                                 style={{
                                     width: "100%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     clipPath: matchesSM ? null
                                         : "polygon(0% 0%, 100% 20%, 100% 100%, 0% 100%)",
                                 }}
                            />
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Optometry offices
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={chiropracticOffices} alt="chiropracticOffices sets"
                                 style={{
                                     width: "100%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: matchesSM ? null : "22%",
                                     clipPath: matchesSM ? null
                                         : "polygon(0% 0%, 100% 20%, 100% 100%, 0% 100%)",
                                 }}
                            />
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Chiropractic offices
                            </Typography>
                        </Grid>
                    </Grid>


                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={urgentCareOffices} alt="interior decoration"
                                 style={{
                                     width: "100%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: "10px",
                                     clipPath: matchesSM ? "polygon(0% 20%, 100% 0%, 100% 100%, 0% 100%)"
                                         : null,
                                 }}
                            />
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Urgent care facilities
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={pharmacyOutlets} alt="composite pharmacyOutletsing"
                                 style={{
                                     width: "100%",
                                     transition: "0.5s",
                                     userSelect: "none",
                                     marginTop: "10px",
                                     clipPath: matchesSM ? "polygon(0% 0%, 100% 20%, 100% 100%, 0% 100%)"
                                         : null,
                                 }}
                            />
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Pharmacy outlets
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={clinicsAndHospitals} alt="room clinicsAndHospitals"
                                 style={{width: "100%", transition: "0.5s", userSelect: "none", marginTop: "10px"}}/>
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Clinics and hospitals
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid item md={3} sm={6} xs={6}>
                        <Grid item container direction="column" className={classes.box}>
                            <img src={imageryAndLaboratoryOffices} alt="imageryAndLaboratoryOffices remodels"
                                 style={{width: "100%", transition: "0.5s", userSelect: "none", marginTop: "10px"}}/>
                            <Typography component="h1" variant="h2" align="center" className={classes.serviceText}>
                                Imagery and laboratory offices
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item style={{marginTop: "50px"}}>
                    <Button component={Link} href={"/services"} variant="contained" color="primary">
                        More Detail &#8594;
                    </Button>
                </Grid>

            </Grid>
        </React.Fragment>

    );
}
